import { useState } from "react";
import AccessAndSegurityForm from "../../Organisms/AccessAndSegurityForm/AccessAndSegurityForm";
import DataCompanyForm from "../../Organisms/DataCompanyForm/DataCompanyForm";
import FormPersonalData from "../../Organisms/FormPersonalData/FormPersonalData";
import GroupOfButtons from "../../Molecules/GroupOfButtons/GroupOfButtons";
import HeaderTitle from "../../Molecules/HeaderTitle/HeaderTitle";

const AccountInformation = () => {
  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
    showForm3: false,
  });

  return (
    <div className="nd-grid rows-gap-3">
      <HeaderTitle headerText="Información de la cuenta"/>
      <div>
        <GroupOfButtons
          content={{
            first: "Datos de empresa",
            second: "Representante de la empresa",
            third: "Acceso y seguridad",
          }}
          formsHandler={formsHandler}
          setFormsHandler={setFormsHandler}
        />
      </div>

      {formsHandler.showForm1 && <DataCompanyForm /> }
      {formsHandler.showForm2 && <FormPersonalData /> }
      {formsHandler.showForm3 && <AccessAndSegurityForm />}
    </div>
  );
};

export default AccountInformation;
